export const headerFertiProduct = [
  "ID Prodotto",
  "Prodotto",
  "N",
  "P2O5",
  "K2O",
  "CaO",
  "MgO",
  "SO3",
  "€/kg",
  "Conducibil. mS/cm",
  "Peso specifico kg/l",
  "Coeff. solubilizz.",
];

export const fertiProductRowsDefault = [
  {
    productId: "00001",
    product: "Hascon 32",
    countN: 32,
    countP2O5: 0,
    countK2O: 0,
    countCaO: 0,
    countMgO: 0,
    countSO3: 0,
    countEurokg: [
      ["00001", 2.36],
      ["00002", 2.36],
    ],
    conducivity: 0.85,
    specificWeight: 1.3,
    solubilCoeff: 1,
  },
  {
    productId: "00002",
    product: "GreenCal",
    countN: 9,
    countP2O5: 0,
    countK2O: 0,
    countCaO: 15,
    countMgO: 0,
    countSO3: 0,
    countEurokg: [
      ["00001", 1.27],
      ["00002", 1.27],
    ],
    conducivity: 0.69,
    specificWeight: 1.4,
    solubilCoeff: 1,
  },
  {
    productId: "00003",
    product: "GreenPlant 20.20.20",
    countN: 20,
    countP2O5: 20,
    countK2O: 20,
    countCaO: 0,
    countMgO: 0,
    countSO3: 0,
    countEurokg: [
      ["00001", 1.27],
      // ["00002", 1.27],
    ],
    conducivity: 1.4,
    specificWeight: 0,
    solubilCoeff: 0.4,
  },
  {
    productId: "00004",
    product: "CALFON P",
    countN: 8,
    countP2O5: 34,
    countK2O: 16,
    countCaO: 8,
    countMgO: 0,
    countSO3: 0,
    countEurokg: [
      ["00001", 2.03],
      ["00002", 2.03],
    ],
    conducivity: 1.45,
    specificWeight: 0,
    solubilCoeff: 0.4,
  },
  {
    productId: "00005",
    product: "VIT-ORG",
    countN: 2,
    countP2O5: 0,
    countK2O: 6,
    countCaO: 0,
    countMgO: 0,
    countSO3: 0,
    countEurokg: [
      ["00001", 4],
      ["00002", 4],
    ],
    conducivity: 0.4,
    specificWeight: 1.3,
    solubilCoeff: 1,
  },
];
